module.exports = __webpack_public_path__ + "media/images/area/sub_hero_map_aichi-dbd98808cc450d8a63386b3015ef7557.png";